import React, { Component } from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import PipManager from '../../utils/pipManager/PipManager';
import Device from "../../devices/device";

import './styles/ModalErrorGeneric.css';

class ModalEndPlayerCatchup extends Component {
  
  constructor(props) {
    super(props);
    this.buttonsAlign = props.buttonsAlign || 'horizontal';
    this.withCancel = props.withCancel || false;
    this.className = props.className;
    this.aafNewStyle = props.aafNewStyle;
    this.showLogo = props.showLogo;
    this.callbackWhenBack = props.callbackWhenBack;
    this.ms = props.ms
    if (props.buttons) {
      const tmp = props.buttons.map(button => {
        const newButton = Object.assign({}, button);
        const cb = newButton.props.onClick;
        newButton.props.onClick = (e) => {
          props.handleClose(e, cb);
          PipManager.resizePIP();
        };
        return newButton;
      });
      this.buttons = [...props.buttons, ...tmp];
    } else {
      this.buttons = [];
    }
    this.state = {
      title: props.title,
      interval: null,
      countdown: props.countdown
    }
  }

  //Se migró esta funcion al ModalWrapper
  //PipManager.closePIP(Device,false);

  componentDidMount() {
    

      const interval = setInterval(() => {
        // this.interval.callback();
        if(this.state.countdown === 1) {
          const lengthButtons = this.buttons.length;
          return this.buttons[lengthButtons - 1].props.onClick();
        }
        const title = Translator.get("playing_modal_secondsToStart_label", "Continúa viendo en @seconds segundos");
        this.setState(previous => ({
          ...previous, 
          countdown: previous.countdown - 1,
          title: title.replace("@seconds", previous.countdown - 1)
        }));
      }, this.ms);
      const title = Translator.get("playing_modal_secondsToStart_label", "Continúa viendo en @seconds segundos");

      this.setState(previous => ({
        ...previous, 
        interval, 
        title: title.replace("@seconds", previous.countdown || 10),  
        countdown: previous.countdown || 10 
      }))
  }

  componentWillUnmount() {
    if(this.state.interval) {
      clearInterval(this.state.interval);
    }
  }

  render() {
    const p = {
      buttonsAlign: this.buttonsAlign,
      buttons: this.buttons,
      className: this.className,
      aafNewStyle: this.aafNewStyle,
      showLogo: this.showLogo,
      callbackWhenBack: this.callbackWhenBack
      };
    if (this.state.title) p['title'] = this.state.title;
    return <ModalWrapper {...p} />;
  }
}

export default withOnClose(ModalEndPlayerCatchup);


// WEBPACK FOOTER //
// ./src/components/Modal/ModalEndPlayerCatchup.jsx